<div class="dialog-container">
    <h4 mat-dialog-title>{{ data.title }}</h4>
    <div mat-dialog-content [awaitAnimations]="true" *ngIf="!isLoading" class="dialog-content">
        <mat-stepper class="example-stepper" [orientation]="(stepperOrientation | async)" [linear]="isLinear" #stepper>
            <mat-step [stepControl]="employeeDetailsGroup" [completed]="true" label="Employee Details"
                *ngIf="accountInfo?.isSuperUser">
                <form [formGroup]="employeeDetailsGroup" class="mt-2">
                    <input matInput formControlName="cbpartnerID" hidden>
                    <div class="row">
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Employee ID</mat-label>
                            <input matInput formControlName="employeeId" placeholder="Enter Employee ID" required>
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Password</mat-label>
                            <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
                                placeholder="Employee Password" required>

                            <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                                [attr.aria-label]="'Toggle password visibility'" [attr.aria-pressed]="!hidePassword"
                                type="button">
                                <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Device Limit</mat-label>
                            <input matInput type="number" formControlName="device" placeholder="Enter Device Limit"
                                required>
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="firstName" placeholder="Enter First Name" required>
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="lastName" placeholder="Enter Last Name" required>
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Department</mat-label>
                            <input type="text" matInput [formControl]="departmentCtrl" [matAutocomplete]="autoDept"
                                required>
                            <mat-autocomplete #autoDept="matAutocomplete"
                                (optionSelected)="onDepartmentSelected($event.option.value)">
                                <mat-option *ngFor="let dept of filteredDepartments | async"
                                    [value]="dept.departmentName">
                                    {{ dept.departmentName }}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-icon-button matSuffix tabindex="-1">
                                <mat-icon>arrow_drop_down</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Branch</mat-label>
                            <input type="text" matInput [formControl]="branchCtrl" [matAutocomplete]="autoBranch"
                                required>
                            <mat-autocomplete #autoBranch="matAutocomplete"
                                (optionSelected)="onBranchSelected($event.option.value)">
                                <mat-option *ngFor="let branch of filteredBranches | async" [value]="branch.branchName">
                                    {{ branch.branchName }}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-icon-button matSuffix tabindex="-1">
                                <mat-icon>arrow_drop_down</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Payroll</mat-label>
                            <input type="text" matInput [formControl]="payrollCtrl" [matAutocomplete]="autoPayroll"
                                required>
                            <mat-autocomplete #autoPayroll="matAutocomplete"
                                (optionSelected)="onPayrollSelected($event.option.value)">
                                <mat-option *ngFor="let payroll of filteredPayrolls | async"
                                    [value]="payroll.payrollType">
                                    {{ payroll.payrollType }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Job Type</mat-label>
                            <input type="text" matInput [formControl]="jobCtrl" [matAutocomplete]="autoJob" required>
                            <mat-autocomplete #autoJob="matAutocomplete"
                                (optionSelected)="onJobSelected($event.option.value)">
                                <mat-option *ngFor="let job of filteredJobs | async" [value]="job.jobName">
                                    {{ job.jobName }}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-icon-button matSuffix tabindex="-1">
                                <mat-icon>arrow_drop_down</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Start Date:</mat-label>
                            <input matInput [matDatepicker]="picker3" formControlName="startDate">
                            <mat-hint>MM/DD/YYYY</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                            <mat-datepicker #picker3></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>End Date:</mat-label>
                            <input matInput [matDatepicker]="picker4" formControlName="endDate">
                            <mat-hint>MM/DD/YYYY</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                            <mat-datepicker #picker4></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Payment Rule</mat-label>
                            <mat-select formControlName="paymentRule" required>
                                <mat-option *ngFor="let rule of paymentRule" [value]="rule.value">
                                    {{rule.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="input-box row mt-2">
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Unpaid Lunch Break (minutes)</mat-label>
                            <input matInput type="number" formControlName="unpaidLunchBreak">
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Unpaid Coffee Break (minutes)</mat-label>
                            <input matInput type="number" formControlName="unpaidCoffeeBreak">
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Grace Period (minutes)</mat-label>
                            <input matInput type="number" formControlName="gracePeriod">
                        </mat-form-field>
                    </div>
                    <div class="input-box row mt-2" *ngIf="selectedPayrollType === 'FS'">
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Max Overtime (hr)</mat-label>
                            <input matInput type="number" formControlName="maxOvertime">
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Regular Hours (hr)</mat-label>
                            <input matInput type="number" formControlName="regularHours">
                        </mat-form-field>
                    </div>
                    <div class="input-box row mt-2" *ngIf="selectedPayrollType === 'SFL'">
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>First Time In Buffer (minutes)</mat-label>
                            <input matInput type="number" formControlName="firstTimeInBuffer">
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Last Time In Buffer (minutes)</mat-label>
                            <input matInput type="number" formControlName="lastTimeInBuffer">
                        </mat-form-field>
                    </div>
                    <div class="input-box row mt-2">
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Total Vacation Leave</mat-label>
                            <input matInput type="number" formControlName="totalVacation">
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Total Sick Leave</mat-label>
                            <input matInput type="number" formControlName="totalSick">
                        </mat-form-field>
                    </div>
                    <div class="input-box row mt-2">
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Available Vacation Leave</mat-label>
                            <input matInput type="number" formControlName="availableVacation">
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Available Sick Leave</mat-label>
                            <input matInput type="number" formControlName="availableSick">
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-checkbox class="col-lg-4 col-md-4 col-sm-12" formControlName="allowTimeEntry"
                            matTooltip="Allow employee to record their time logs in personal tracker.">Allow Time
                            Entry</mat-checkbox>
                        <mat-checkbox class="col-lg-4 col-md-4 col-sm-12" formControlName="allowPayslip"
                            matTooltip="Allow employee to view/generate their payslip in personal tracker.">Allow
                            Payslip/Payroll</mat-checkbox>
                        <mat-checkbox class="col-lg-4 col-md-4 col-sm-12" formControlName="timesheetApproval"
                            matTooltip="Allow employee to approve their timesheet in personal tracker.">Allow Timesheet
                            Approval</mat-checkbox>
                    </div>
                    <div class="row">
                        <mat-checkbox class="col-lg-4 col-md-4 col-sm-12" formControlName="allowCamera"
                            matTooltip="Allow employee to take a selfie every time entries in personal tracker.">Allow
                            Camera</mat-checkbox>
                        <mat-checkbox class="col-lg-4 col-md-4 col-sm-12" formControlName="allowClient"
                            matTooltip="Allow employee to use time management/calendar to record their time logs.">Allow
                            Client</mat-checkbox>
                    </div>
                    <div class="mt-3">
                        <button mat-raised-button class="save-button" (click)="firstFormSave()"
                            [disabled]="!employeeDetailsGroup.valid" type="submit">Save</button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="scheduleDetailsGroup" [completed]="true" label="Employee Schedule">
                <form [formGroup]="scheduleDetailsGroup" (ngSubmit)="secondFormSave()">
                    <div *ngFor="let schedule of schedules.controls; let i = index">
                        <ng-container [formGroup]="schedule" *ngIf="currentScheduleIndex === i">
                            <div class="row pagination-container">
                                <div class="pagination">
                                    <a [class.disabled]="currentScheduleIndex <= 0"
                                        (click)="navigateToScheduleFirst()"
                                        matTooltip="Previous">&lt;&lt;</a>
                                    <a [class.disabled]="currentScheduleIndex <= 0"
                                        (click)="navigateToSchedule(currentScheduleIndex - 1)"
                                        matTooltip="Previous">&lt;</a>
                                    <span>{{ currentScheduleIndex + 1 }}/{{ schedules.length }}</span>
                                    <a [class.disabled]="currentScheduleIndex >= schedules.length - 1"
                                        (click)="navigateToSchedule(currentScheduleIndex + 1)"
                                        matTooltip="Next">&gt;</a>
                                    <a [class.disabled]="currentScheduleIndex >= schedules.length - 1"
                                        (click)="navigateToScheduleLast()"
                                        matTooltip="Next">&gt;&gt;</a>
                                </div>
                            </div>
                            <div class="period-filter">
                                <mat-form-field appearance="outline" class="col-lg-4 p-0">
                                    <mat-label>Filter by Period</mat-label>
                                    <mat-select [(value)]="selectedPeriod"
                                        (selectionChange)="filterSchedulesByPeriod($event.value)">
                                        <mat-option *ngFor="let period of payrollPeriod" [value]="period.hrperiodID">
                                            {{ period.payrollName }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="schedule-buttons mt-3">
                                <div>
                                    <button mat-raised-button type="button" (click)="addSchedule()">Add
                                        Schedule</button>
                                    <button class="ml-2" type="button" *ngIf="!isNewSchedule"
                                        [disabled]="!scheduleDetailsGroup.valid" mat-raised-button
                                        (click)="addAndCopySchedule(i)"><mat-icon>content_copy</mat-icon><span>Duplicate</span></button>
                                </div>
                                <button mat-raised-button *ngIf="!isSchedule" type="button"
                                    (click)="deleteSchedule(i)">Delete</button>
                                <button mat-raised-button *ngIf="isSchedule" (click)="deleteWorkdaysDialog()"
                                    type="button">Delete</button>
                            </div>
                            <input matInput formControlName="scheduleID" hidden>
                            <input matInput formControlName="cbpartnerID" hidden>
                            <div class="row">
                                <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                                    <mat-label>Period</mat-label>
                                    <mat-select formControlName="period" (selectionChange)="onPeriodChange(i)">
                                        <mat-option *ngFor="let payroll of payrollPeriod" [value]="payroll.hrperiodID">
                                            {{payroll.payrollName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="col-lg-4 col-md-4 col-sm-12">
                                    <mat-label>Day of Week</mat-label>
                                    <mat-select formControlName="weekDay">
                                        <mat-option *ngFor="let day of weekdays" [value]="day.value">{{
                                            day.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="col-lg-4 col-md-4 col-sm-12">
                                    <mat-checkbox formControlName="isRestDay">Rest Day</mat-checkbox>&nbsp;
                                    <mat-checkbox formControlName="isCustomWorkday">Custom
                                        Workday</mat-checkbox>
                                </div>
                            </div>
                            <div class="row">
                                <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                                    <mat-label>Valid From:</mat-label>
                                    <input matInput [matDatepicker]="picker" formControlName="validFrom">
                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                    <mat-datepicker-toggle class="mat-mdc-icon-button" matSuffix
                                        [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                                    <mat-label>Valid To:</mat-label>
                                    <input matInput [matDatepicker]="picker2" formControlName="validTo">
                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                    <mat-datepicker-toggle class="mat-mdc-icon-button" matSuffix
                                        [for]="picker2"></mat-datepicker-toggle>
                                    <mat-datepicker #picker2></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field class="col-lg-4 col-md-4 col-sm-12"
                                    *ngIf="schedule.get('isCustomWorkday')?.value" appearance="outline">
                                    <mat-label>Custom Workday Date:</mat-label>
                                    <input matInput [matDatepicker]="customWorkday" formControlName="customWorkdayDate">
                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                    <mat-datepicker-toggle class="mat-mdc-icon-button" matSuffix
                                        [for]="customWorkday"></mat-datepicker-toggle>
                                    <mat-datepicker #customWorkday></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-4 col-md-4 col-sm-6 order-1">
                                    <div class="form-group row">
                                        <mat-form-field class="example-full-width col-12" appearance="outline">
                                            <mat-icon class="icon" (click)="timepicker1.open()">access_time</mat-icon>
                                            <input matInput [ngxTimepicker]="timepicker1" formControlName="rampTime1"
                                                placeholder="Time 1">
                                            <ngx-material-timepicker #timepicker1></ngx-material-timepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-6 order-2">
                                    <div class="form-group row">
                                        <mat-form-field class="example-full-width col-12" appearance="outline">
                                            <mat-icon class="icon" (click)="timepicker2.open()">access_time</mat-icon>
                                            <input matInput [ngxTimepicker]="timepicker2" formControlName="rampTime2"
                                                placeholder="Time 2">
                                            <ngx-material-timepicker #timepicker2></ngx-material-timepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-6 order-3">
                                    <div class="form-group row">
                                        <mat-form-field class="example-full-width col-12" appearance="outline">
                                            <mat-icon class="icon" (click)="timepicker3.open()">access_time</mat-icon>
                                            <input matInput [ngxTimepicker]="timepicker3" formControlName="rampTime3"
                                                placeholder="Time 3">
                                            <ngx-material-timepicker #timepicker3></ngx-material-timepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-6 order-4">
                                    <div class="form-group row">
                                        <mat-form-field class="example-full-width col-12" appearance="outline">
                                            <mat-icon class="icon" (click)="timepicker4.open()">access_time</mat-icon>
                                            <input matInput [ngxTimepicker]="timepicker4" formControlName="rampTime4"
                                                placeholder="Time 4">
                                            <ngx-material-timepicker #timepicker4></ngx-material-timepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-6 order-5">
                                    <div class="form-group row">
                                        <mat-form-field class="example-full-width col-12" appearance="outline">
                                            <mat-icon class="icon" (click)="timepicker5.open()">access_time</mat-icon>
                                            <input matInput [ngxTimepicker]="timepicker5" formControlName="rampTime5"
                                                placeholder="Time 5">
                                            <ngx-material-timepicker #timepicker5></ngx-material-timepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-6 order-6">
                                    <div class="form-group row">
                                        <mat-form-field class="example-full-width col-12" appearance="outline">
                                            <mat-icon class="icon" (click)="timepicker6.open()">access_time</mat-icon>
                                            <input matInput [ngxTimepicker]="timepicker6" formControlName="rampTime6"
                                                placeholder="Time 6">
                                            <ngx-material-timepicker #timepicker6></ngx-material-timepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="mt-1">
                        <button mat-raised-button class="save-button" [disabled]="!scheduleDetailsGroup.valid"
                            type="submit">Save</button>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="ratesDetailsGroup" [completed]="true" label="Employee Attribute"
                *ngIf="accountInfo?.isSuperUser">
                <form [formGroup]="ratesDetailsGroup" (ngSubmit)="thirdFormSave()">
                    <div *ngFor="let rate of rates.controls; let i = index">
                        <ng-container [formGroup]="rate" *ngIf="currentRateIndex === i">
                            <div class="row pagination-container">
                                <div class="pagination">
                                    <a [class.disabled]="currentRateIndex <= 0"
                                        (click)="navigateToRates(currentRateIndex - 1)" matTooltip="Previous">&lt;</a>
                                    <span>{{ currentRateIndex + 1 }}/{{ rates.length }}</span>
                                    <a [class.disabled]="currentRateIndex >= rates.length - 1"
                                        (click)="navigateToRates(currentRateIndex + 1)" matTooltip="Next">&gt;</a>
                                </div>
                            </div>
                            <div class="schedule-buttons mt-3">
                                <button mat-raised-button (click)="addRates()">Add Attribute</button>
                                <button mat-raised-button *ngIf="!isRate" (click)="deleteRates(i)">Delete</button>
                            </div>
                            <input matInput formControlName="hrAttributeID" hidden>
                            <input matInput formControlName="cbpartnerID" hidden>
                            <div class="row">
                                <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                                    <mat-label>Payroll Concept</mat-label>
                                    <mat-select formControlName="payrollConcept">
                                        <mat-option *ngFor="let concept of payrollConcept"
                                            [value]="concept.HR_Concept_ID">
                                            {{concept.conceptName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                                    <mat-label>Salary Scale</mat-label>
                                    <mat-select formControlName="salaryScale">
                                        <mat-option *ngFor="let salary of salaryScale"
                                            [value]="salary.RAMP_Salary_Scale_ID">
                                            {{salary.salaryName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="row">
                                <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                                    <mat-label>Valid From:</mat-label>
                                    <input matInput [matDatepicker]="ratesDetailsGroupPicker"
                                        formControlName="validFrom">
                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                    <mat-datepicker-toggle matSuffix
                                        [for]="ratesDetailsGroupPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #ratesDetailsGroupPicker></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                                    <mat-label>Valid To:</mat-label>
                                    <input matInput [matDatepicker]="ratesDetailsGroupPicker2"
                                        formControlName="validTo">
                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                    <mat-datepicker-toggle matSuffix
                                        [for]="ratesDetailsGroupPicker2"></mat-datepicker-toggle>
                                    <mat-datepicker #ratesDetailsGroupPicker2></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="input-box row mt-3">
                                <div class="col-lg-4 col-md-4 col-sm-12">
                                    <mat-checkbox formControlName="dailyRate">
                                        Daily Rate
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="mt-3">
                                <button mat-raised-button class="save-button" [disabled]="!ratesDetailsGroup.valid"
                                    type="submit">Save</button>
                            </div>
                        </ng-container>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="addressDetailsGroup" [completed]="true" label="Address"
                *ngIf="accountInfo?.isSuperUser">
                <form [formGroup]="addressDetailsGroup" (ngSubmit)="fourthFormSave()">
                    <div class="w-100">
                        <p>4. Setup Address</p>
                    </div>
                    <div class="row">
                        <input matInput formControlName="addressId" hidden>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Street Address</mat-label>
                            <input matInput formControlName="streetAddress" placeholder="Street Address" required>
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Country</mat-label>
                            <input type="text" matInput [formControl]="countryCtrl" [matAutocomplete]="autoCountry"
                                required>
                            <mat-autocomplete #autoCountry="matAutocomplete"
                                (optionSelected)="onCountrySelected($event.option.value)">
                                <mat-option *ngFor="let country of filteredCountries | async"
                                    [value]="country.countryName">
                                    {{ country.countryName }}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-icon-button matSuffix tabindex="-1">
                                <mat-icon>arrow_drop_down</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Province</mat-label>
                            <input type="text" matInput [formControl]="regionCtrl" [matAutocomplete]="autoRegion"
                                required>
                            <mat-autocomplete #autoRegion="matAutocomplete"
                                (optionSelected)="onRegionSelected($event.option.value)">
                                <mat-option *ngFor="let region of filteredRegions | async" [value]="region.name">
                                    {{ region.name }}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-icon-button matSuffix tabindex="-1">
                                <mat-icon>arrow_drop_down</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>City</mat-label>
                            <input type="text" matInput [formControl]="provinceCtrl" [matAutocomplete]="autoProvince"
                                required>
                            <mat-autocomplete #autoProvince="matAutocomplete"
                                (optionSelected)="onProvinceSelected($event.option.value)">
                                <mat-option *ngFor="let province of filteredProvinces | async" [value]="province.name">
                                    {{ province.name }}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-icon-button matSuffix tabindex="-1">
                                <mat-icon>arrow_drop_down</mat-icon>
                            </button>
                        </mat-form-field>
                        <!-- <mat-form-field class="col-lg-4 col-md-4 col-sm-12">
                            <mat-label>City</mat-label>
                            <input matInput formControlName="city" placeholder="City" required>
                        </mat-form-field> -->
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Postal Code</mat-label>
                            <input matInput formControlName="postal" placeholder="Postal Code" required>
                        </mat-form-field>
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12" appearance="outline">
                            <mat-label>Phone</mat-label>
                            <input matInput formControlName="phone" placeholder="phone">
                        </mat-form-field>
                    </div>
                    <!-- <div class="row">
                        <mat-form-field class="col-lg-4 col-md-4 col-sm-12">
                            <mat-label>Phone</mat-label>
                            <input matInput formControlName="phone" placeholder="phone">
                        </mat-form-field>
                    </div> -->
                    <div class="mt-3">
                        <button mat-raised-button class="save-button" [disabled]="!addressDetailsGroup.valid"
                            type="submit">Save</button>
                    </div>
                </form>
            </mat-step>
        </mat-stepper>
    </div>
    <div mat-dialog-content *ngIf="isLoading" class="loading-container">
        <mat-spinner></mat-spinner>
        <p>Fetching employee details...</p>
    </div>
    <!-- <div mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="previousStep()" [disabled]="!canGoBack">Previous</button>
        <button mat-button (click)="nextStep()" [disabled]="!canGoForward">Next</button>
    </div> -->
</div>